import { toast } from 'react-toastify';

export const TOAST_TIMEOUT = 3000;
const toastOptions = {
  position: toast.POSITION.TOP_CENTER,
  autoClose: TOAST_TIMEOUT,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

export const successNotification = message => {
  toast.success(message, toastOptions);
};

export const errorNotification = message => {
  toast.error(message, toastOptions);
};
